import { AttributeDTO, FullAttributesDTO } from '../apiModule'

function isPlaceholder(value?: string | null): boolean {
  return (value ?? '').trim() === '-'
}

function sanitizeList(list?: Array<AttributeDTO>): Array<AttributeDTO> | undefined {
  return list?.filter((item) => !isPlaceholder(item.value))
}

export function sanitizeFullAttributes(attributes: FullAttributesDTO): FullAttributesDTO {
  return {
    ...attributes,
    made_IN: sanitizeList(attributes.made_IN),
    brand: sanitizeList(attributes.brand),
    consumer_TYPE: sanitizeList(attributes.consumer_TYPE),
    product_TYPE: sanitizeList(attributes.product_TYPE),
    edit_STATUS: sanitizeList(attributes.edit_STATUS),
    causal_1: sanitizeList(attributes.causal_1),
    causal_2: sanitizeList(attributes.causal_2),
  }
}
